import { Fab } from '@mui/material';
import React from 'react';

interface SocialMediaProps {
    link: string;
    icon: React.ReactNode;
    borderColor?: string;
}

const SocialMedia: React.FC<SocialMediaProps> = ({ link, icon, borderColor = '#999' }) => {
    return (
        <Fab
            onClick={() => window.open(link)}
            sx={(theme) => ({
                backgroundColor: theme.palette.background.paper,
                border: `2px solid ${borderColor}`,
                transition: 'all 0.25s ease',
                boxShadow: 0,
                '&:hover': {
                    backgroundColor: theme.palette.action.hover,
                },
            })}
        >
            {icon}
        </Fab>


    );
}

export default SocialMedia;